import * as React from 'react'

function IconRectangle({
  color,
  isFill,
  props,
}: {
  color: string
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={155}
      viewBox="0 0 104 155"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#filter3_rectangle)">
            <path
              d="M88.401 154.034H15.6c0-8.613-6.987-15.6-15.599-15.6V15.6c8.612 0 15.598-6.987 15.598-15.6h72.803c0 8.613 6.987 15.6 15.599 15.6v122.834c-8.612 0-15.599 6.987-15.599 15.6z"
              fill="#fff"
            />
            <path
              d="M88.401 154.034H15.6c0-8.613-6.987-15.6-15.599-15.6V15.6c8.612 0 15.598-6.987 15.598-15.6h72.803c0 8.613 6.987 15.6 15.599 15.6v122.834c-8.612 0-15.599 6.987-15.599 15.6z"
              fill={color}
            />
            <path
              d="M23.555 144.024a25.783 25.783 0 00-13.546-13.547V23.586a25.785 25.785 0 0013.546-13.547h56.89a25.785 25.785 0 0013.546 13.547v106.891a25.783 25.783 0 00-13.545 13.547H23.555z"
              stroke="#fff"
              strokeWidth={0.75}
              strokeMiterlimit={10}
            />
          </g>
          <defs>
            <filter
              id="filter3_rectangle"
              x={0}
              y={0}
              width={104}
              height={154.034}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M88.401 154.034H15.6c0-8.613-6.987-15.6-15.599-15.6V15.6c8.612 0 15.598-6.987 15.598-15.6h72.803c0 8.613 6.987 15.6 15.599 15.6v122.834c-8.612 0-15.599 6.987-15.599 15.6z"
            fill="#fff"
          />
          <path
            d="M88.401 154.034H15.6c0-8.613-6.987-15.6-15.599-15.6V15.6c8.612 0 15.598-6.987 15.598-15.6h72.803c0 8.613 6.987 15.6 15.599 15.6v122.834c-8.612 0-15.599 6.987-15.599 15.6z"
            fill={color}
          />
          <path
            d="M23.555 144.024a25.783 25.783 0 00-13.545-13.547V23.586a25.784 25.784 0 0013.545-13.547h56.89a25.784 25.784 0 0013.546 13.547v106.891a25.783 25.783 0 00-13.545 13.547h-56.89z"
            fill="#fff"
          />
        </>
      )}
    </svg>
  )
}

export default IconRectangle
